var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SharePercentage',{attrs:{"index":_vm.index,"no-save":_vm.noSave,"errors-post":_vm.errorsPost.share,"location":_vm.location,"id":`${_vm.location}${_vm.index}share`},model:{value:(_vm.form.share),callback:function ($$v) {_vm.$set(_vm.form, "share", $$v)},expression:"form.share"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }